import React from "react"
import { useLocation } from "react-router-dom"
import FloatingHelpButton from "./FloatingHelpButton"
import { useHelp } from "./HelpContext"
import HelpPopup from "./HelpPopup"

const GlobalHelp: React.FC = () => {
    const location = useLocation()
    const isTrackingPage = location.pathname.includes("/rastreamento")

    const {
        showHelpButton,
        showHelpPopup,
        handleShowHelpPopup,
        handleCloseHelpPopup,
        handleWhatsAppRedirect
    } = useHelp()

    return (
        <>
            <FloatingHelpButton
                isVisible={showHelpButton}
                onClick={handleShowHelpPopup}
            />
            <HelpPopup
                isOpen={showHelpPopup}
                onClose={handleCloseHelpPopup}
                onWhatsApp={handleWhatsAppRedirect}
                isTrackingPage={isTrackingPage}
            />
        </>
    )
}

export default GlobalHelp
